import React, { useState, useRef, useEffect, useMemo } from "react";
import { X } from "lucide-react";

const CommonGroupBy = ({
  groupBy,
  onSetGroupBy,
  options = [],
  placeholderIcon: PlaceholderIcon,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const activeOption = useMemo(
    () => options.find((o) => o.value === groupBy),
    [options, groupBy],
  );

  const TriggerIcon = activeOption?.Icon ?? PlaceholderIcon;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    onSetGroupBy(value);
    setOpen(false);
  };

  return (
    <div className="relative w-fit" ref={dropdownRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-lg border border-gray-300 dark:border-gray-800 px-3.5 py-2 cursor-pointer bg-white dark:bg-gray-900"
      >
        {TriggerIcon ? (
          <TriggerIcon size={16} className="text-gray-700 dark:text-gray-300 shrink-0" />
        ) : null}

        <span className="text-xs font-semibold text-gray-700 dark:text-gray-200">
          {activeOption ? `Group by ${activeOption.label}` : "Group by"}
        </span>

        {groupBy && (
          <X
            size={14}
            className="hover:text-error-500 text-secondary dark:text-secondary-light cursor-pointer shrink-0"
            onClick={(e) => {
              e.stopPropagation();
              onSetGroupBy(null);
            }}
          />
        )}
      </div>

      {open && (
        <div className="absolute z-[9999999999] mt-2 w-full rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg min-w-[140px]">
          {options.map(({ value, label, Icon: RowIcon }) => (
            <div
              key={value}
              onClick={() => handleSelect(value)}
              className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-800 dark:text-gray-200 flex items-center gap-2 ${
                groupBy === value
                  ? "bg-secondary-transparent dark:bg-secondary/20 font-medium text-secondary dark:text-secondary-light hover:bg-secondary-transparent"
                  : ""
              }`}
            >
              <RowIcon
                size={14}
                className={
                  groupBy === value ? "text-secondary dark:text-secondary-light" : "text-gray-600 dark:text-gray-400"
                }
              />
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommonGroupBy;
